import { Text18Size, TitleH1 } from "components/generic";
import { useTranslation, Trans } from "react-i18next";

import { LiItem } from "../FindRoom/styles";
import { HeaderSEO } from "components/headerSEO";
import { HomeDiv, ItemLink, LimitWidthSection } from "../styles";
import { ISeo } from "interfaces/intarfaces";

export const Privacy = () => {
  const { t } = useTranslation("privacy");

  const textLines: string[] = t("text", { returnObjects: true });
  const seo = t("seo", { returnObjects: true }) as ISeo;

  const links: React.ReactNode[] = (
    t("links", { returnObjects: true }) as string[]
  ).map((link) => (
    <ItemLink
      href={link!}
      target={`${link.startsWith("#") ? "_self" : "_blank"}`}
      key={link}
    />
  ));

  return (
    <HomeDiv>
      {seo && <HeaderSEO {...seo} />}
      <LimitWidthSection style={{ textAlign: "left" }}>
        <TitleH1 m="0 0 24px 0">{t("title")}</TitleH1>
        {textLines.length &&
          textLines.map((_, num) => (
            <Trans
              t={t}
              i18nKey={"text." + num}
              parent={Text18Size}
              components={[
                <LiItem style={{ padding: "0 0 0 20px" }} />,
                ...links,
              ] as any[]}
              key={num}
            />
          ))}
      </LimitWidthSection>
    </HomeDiv>
  );
};
